// Third party
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: '',
  },
});

const CreateUpdateVcatKitSchema = yup.object({
  eyetracker_type: yup.string().required(''),
  serial: yup.string().required(''),
  headset_status: yup.string().min(1, '').required(),
  account_root_id: yup.number().min(1, '').required(),
  weapon: yup.string().min(1, '').required(),
});

export { CreateUpdateVcatKitSchema };